import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { Constants } from "../interfaces/constants";
import { AdminGuard } from "../services/admin-guard.service";
import { ServiceDeskGuard } from "../services/servicedesk-guard.service";
import { AdminEditComponent as AdminSubstituteEditComponent } from "../substitute/components/admin/admin-edit.component";
import { AdminViewComponent as AdminSubstituteViewComponent } from "../substitute/components/admin/admin-view.component";
import { AdminViewComponent as UserViewComponent } from "../user/components/admin-view.component";
import { AdminEditUserRoleComponent } from "../user/role/admin-edit-user-role";
import { AdminRoleComponent } from "../user/role/admin-role";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { SettingsComponent } from "./settings/settings.component";

const routes: Routes = [
  {
    path: Constants.routePaths.admin,
    children: [
      {
        path: "",
        pathMatch: "full",
        component: AdminDashboardComponent,
        canActivate: [AdminGuard]
      },
      {
        path: Constants.routePaths.settings,
        component: SettingsComponent,
        canActivate: [AdminGuard]
      },
      {
        path: Constants.routePaths.substitutes,
        canActivate: [ServiceDeskGuard],
        children: [
          {
            path: "",
            pathMatch: "full",
            component: AdminSubstituteViewComponent
          },
          {
            path: `user/:${Constants.routeParams.userId}`,
            component: AdminSubstituteEditComponent
          }
        ]
      },
      {
        path: Constants.routePaths.users,
        canActivate: [AdminGuard],
        children: [
          {
            path: "",
            pathMatch: "full",
            component: UserViewComponent
          },
          {
            path: `id/:${Constants.routeParams.userId}`,
            component: AdminEditUserRoleComponent
          }
        ]
      },
      {
        path: Constants.routePaths.roles,
        canActivate: [AdminGuard],
        children: [
          {
            path: "",
            pathMatch: "full",
            component: AdminRoleComponent
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
